import React, { useEffect } from 'react'
import Button from '../components/Button';
import CallForAction from '../components/CallForAction';
import Checkmark from '../components/Checkmark';
import Instructions from '../components/Instructions';

interface ImageProps {
	src: string;
	alt: string;
}

const Image: React.FC<ImageProps> = ({ src, alt }) => {
	return <img loading="lazy" src={src} alt={alt} className="w-full aspect-square" />;
};

interface ImageContainerProps {
	image: ImageProps;
}

const ImageContainer: React.FC<ImageContainerProps> = ({ image }) => {
	return (
		<div className="flex flex-col max-md:ml-0 max-md:w-full">
			<div className="flex flex-col justify-center max-md:mt-10">
				<Image src={image.src} alt={image.alt} />
			</div>
		</div>
	);
};

const images_row_0 = [
	{
		src: "https://cdn.builder.io/api/v1/image/assets/TEMP/93e327adafe04f2226b09b9fd3b1ea2fe762041760eb3f63a1fff329bab912fc?apiKey=087fb013add7429984c0d2e3ef2c4ec1&",
		alt: "Image 1",
	},
	{
		src: "https://cdn.builder.io/api/v1/image/assets/TEMP/e69707644c38588b7a305f6f79f2c0bd3053e86d887de82cc6469475dd07680b?apiKey=087fb013add7429984c0d2e3ef2c4ec1&",
		alt: "Image 2",
	},
	{
		src: "https://cdn.builder.io/api/v1/image/assets/TEMP/fb91106e9200e24ef14d938fa20ffaf81997daec5199562b16326bbe005e32dc?apiKey=087fb013add7429984c0d2e3ef2c4ec1&",
		alt: "Image 3",
	},
];

const images_row_1 = [
	{
		src: "https://cdn.builder.io/api/v1/image/assets/TEMP/44a9a8406153792d29bd302aa7459ddecdc172edea0168695e45549f81dad0cb?apiKey=087fb013add7429984c0d2e3ef2c4ec1&",
		alt: "Image 4",
	},
	{
		src: "https://cdn.builder.io/api/v1/image/assets/TEMP/eef379a5198e68d0e7f371251565acc012acc96f96296c25694c14e9abd91911?apiKey=087fb013add7429984c0d2e3ef2c4ec1&",
		alt: "Image 5",
	},

]

const steps = [
	{
		stepNumber: 1,
		title: "Register Ad Campaign",
		description:
			"Make sure your phantom wallet is connected. Create an Ad Campaign Name and a link to the image / text that you want.",
	},
	{
		stepNumber: 2,
		title: "Apply for Publishers",
		description:
			"Billboard supports only PMPs. This gives publishers authority over which ads run on their websites. Advertisers therefore must apply for each publisher they wish to run their ads on.",
	},
	{
		stepNumber: 3,
		title: "Win Inventory at Auctions",
		description:
			"Billboard finds the right price per time-bin with auctions. As an advertisers you have to bid for the time slots that you are interested in.",
	},
	{
		stepNumber: 4,
		title: "Validate impressions",
		description:
			"Publishers are obligated to link the page where they run the ad. This allows billboard validators to identify and eliminate ad fraud. You can make sure yourself that the ad was displayed during time bin by following the link.",
	},
];

const adFormats = [
	{ name: "Text", checked: true },
	{ name: "Responsive", checked: true },
	{ name: "Banner", checked: true },
	{ name: "Sticky Ads", checked: false },
];

const pricingModels = [
	{ name: "CPT", checked: true },
	{ name: "CPM", checked: false },
];

const trackingOptions = [
	{ name: "Authenticity", checked: true },
	{ name: "Impressions", checked: false },
];

const AdvertiserInfoPage = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [])
	return (
		<>
			<section className="flex md:red-elipse justify-center self-stretch pt-64 pb-48 max-md:mt-10 max-md:py-0" >
				<div className="flex flex-row gap-5 max-md:flex-col max-md:gap-0">
					<div className="w-6/12 max-md:w-full">
						<div className="flex flex-col grow justify-center px-5 py-4 font-bold max-w-[615px] max-md:mt-10 max-md:max-w-full">
							<h1 className="text-5xl bg-clip-text leading-[72px] max-md:max-w-full text-white max-md:text-4xl max-md:leading-[67px]">
								Decentralized DSP Web3 Centeric Ads
							</h1>
							<p className="mt-12 text-2xl leading-9 text-zinc-400 max-md:mt-10 max-md:max-w-full">
								Looking for cheap Ad Campaigns? In need to reach a direct audience? This is where billboard.app comes in! Our publisher network is hand picked and our platform is optimized for cheap Ad Campaigns.
							</p>
							<Button to={"/app/"} className="self-start mt-12 max-md:mt-10 w-72 text-white" background='linear-gradient(62deg, #6100FF 0%, #00FFD1 100%)'>Start Campaign</Button>
						</div>
					</div>
					<div className="w-6/12 max-md:w-full">
						<img
							loading="lazy"
							src={"./assets/teaserImage.png"}
							alt="Hero"
							className="rounded-3xl w-full aspect-[1.05] max-md:mt-10 max-md:max-w-full"
						/>
					</div>
				</div>
			</section>
			<section className="flex justify-center self-stretch py-10 bg-neutral-900 max-md:mt-10">
				<div className="flex flex-col justify-center items-center max-w-full py-10 ">
					<h2 className="justify-center items-center pr-16 pl-20  text-4xl font-bold leading-10 text-center text-white w-[1120px] max-md:px-5 max-md:max-w-full">
						Aside from being <span style={{
							background: 'linear-gradient(62deg, #FFC700 0%, #FF0000 100%)',
							WebkitBackgroundClip: 'text',
							WebkitTextFillColor: 'transparent',
						}}>cheap</span>, you also get
					</h2>
					<div className="flex-wrap justify-center content-center p-2.5 mt-7 max-w-full w-[1028px]">
						<div className="flex gap-5 max-md:flex-col max-md:gap-0">
							{images_row_0.map((image, index) => (
								<ImageContainer key={index} image={image} />
							))}
						</div>
					</div>
					<div className="flex-wrap justify-center content-center p-2.5 mt-7  max-w-full w-[674px]">
						<div className="flex gap-5 max-md:flex-col max-md:gap-0">
							{images_row_1.map((image, index) => (
								<ImageContainer key={index} image={image} />
							))}
						</div>
					</div>
				</div>
			</section>

			<section className="flex justify-center self-stretch py-10 mt-40 max-md:mt-10">
				<div className="flex flex-col self-center max-w-full text-2xl px-5 text-white">
					<h2 className="justify-center items-center self-center py-6 max-w-full text-4xl font-bold leading-10 text-center text-white w-[1120px] max-md:px-5 max-md:mt-10">
						Technical Capabilities
					</h2>
					<div className="flex gap-5 justify-between items-start max-md:flex-wrap max-md:max-w-full min-h-80 ">
						<div className="flex flex-col px-9 py-2.5 self-start rounded-3xl bg-neutral-600 max-md:px-5 max-w-sm max-md:max-w-full">
							<h3 className="self-start ml-4 max-md:ml-2.5">Ad formats</h3>
							<div className="flex  flex-wrap content-start px-2.5 pt-2.5 pb-7">
								{adFormats.map((data, index) => (
									<div key={index} className={"flex gap-2.5"}>
										<div className="flex gap-2.5 px-1.5 py-1">
											<Checkmark isChecked={data.checked} />
											<div>{data.name}</div>
										</div>
									</div>
								))}
							</div>
						</div>
						<div className="flex flex-col items-start self-end py-2.5 pl-9 rounded-3xl bg-neutral-600">
							<h3>Pricing Models</h3>
							<div className="flex flex-col flex-wrap content-start items-start pt-2.5 pr-20 pb-7 pl-2.5 w-full whitespace-nowrap max-md:pr-5">
								{pricingModels.map((data, index) => (
									<div key={index} className="flex gap-2.5 py-1">
										<Checkmark isChecked={data.checked} />
										<div>{data.name}</div>
									</div>
								))}
							</div>
						</div>
						<div className="flex flex-col items-start self-start py-2.5 pl-9 max-w-full rounded-3xl bg-neutral-600 w-[280px] max-md:pl-5">
							<h3>Tracking</h3>
							<div className="flex flex-col flex-wrap content-start px-2.5 pt-2.5 pb-7 w-full">
								{trackingOptions.map((data, index) => (
									<div key={index} className="flex gap-2.5 p-1">
										<Checkmark isChecked={data.checked} />
										<div className="flex-auto">{data.name}</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="flex justify-center py-10 mt-40 self-stretch bg-neutral-800 bg-opacity-50 max-md:px-5 max-md:mt-10 ">
				<Instructions heading={"Your first Solana backed Ad Campaign is a few steps away"} steps={steps} />
			</section>
			<CallForAction />
		</>
	)
}

export default AdvertiserInfoPage;